import CONFIG from "../config/config";

const languageToLocaleMap: { [key: string]: string } = {
    'en': 'EN_US',
    'es': 'ES_ES',
    'it': 'IT_IT',
    'pt': 'PT_PT',
    'uk': 'UK_UA',
    'de': 'DE_DE',
    'pl': 'PL_PL'
  };

export function isSupportedLanguage(type?: string): boolean {
    if (!!type) {
        return CONFIG.SUPPORTED_LANGUAGES.filter(lan => lan.code.toLowerCase() === type.toLowerCase()).length > 0;
    }
    return false;
}

export function languageToLocale(language: string): string {
    return languageToLocaleMap[language] || 'EN_US';
}

/** Contract locale format used by API (e.g. EN_US, PL_PL). */
export const CONTRACT_LOCALES = ['EN_US', 'PL_PL', 'ES_ES', 'DE_DE', 'IT_IT', 'PT_PT', 'UK_UA'] as const;
export type ContractLocale = (typeof CONTRACT_LOCALES)[number];

/** Maps contract locale to i18n translation key for the language label (e.g. global.english). */
export const CONTRACT_LOCALE_TO_LABEL_KEY: Record<string, string> = {
  EN_US: 'global.english',
  PL_PL: 'global.polish',
  PT_PT: 'global.portuguese',
  ES_ES: 'global.spanish',
  IT_IT: 'global.italian',
  DE_DE: 'global.german',
  UK_UA: 'global.ukrainian',
};

/** Maps store country code (from configuration) to contract locale. Fallback: EN_US. */
const countryToContractLocaleMap: { [countryCode: string]: ContractLocale } = {
    US: 'EN_US',
    GB: 'EN_US',
    PL: 'PL_PL',
    ES: 'ES_ES',
    DE: 'DE_DE',
    IT: 'IT_IT',
    PT: 'PT_PT',
    UA: 'UK_UA',
};

export function countryToContractLocale(countryCode: string | undefined): ContractLocale {
    if (!countryCode) return 'EN_US';
    const normalized = countryCode.toUpperCase().trim();
    return countryToContractLocaleMap[normalized] ?? 'EN_US';
}